// 由于fileList不允许修改而导致一些bug,至此修改上传组件
<template>
  <div :class="classes" class="wt-upload-file">
      <el-upload
      :style="{height:height?height+'px':'',width:width?width+'px':''}"
      :action="action"
      ref="upload"
      :headers="headers"
      :disabled="disabled"
      :with-credentials="true"
      :listType="listType"
      :limit="limit"
      :file-list="fileList"
      :before-upload="beforeAvatarUpload"
      :show-file-list="showFileList"
      :multiple="multiple"
      :drag="drag"
      :accept="accept"
      :data="data"
      :on-success="onSuccess"
      :on-remove="onRemove"
      :on-preview="handlePictureCardPreview"
      :auto-upload="autoUpload"
      :class="{'wt-upload-file--no-add':(!isAdd)}">
          <slot name="default"/>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import { Upload } from 'element-ui'
const prefixCls = 'wt-upload-file'

export default {
  name: 'wt-upload-file',
  props: {
    value: {
      type: [Array, Object, String],
      default: function () {
        return []
      }
    },
    action: {
      type: String,
      default: '/apartments/api/apartments/upload-image'
    },
    headers: {
      type: Object,
      default: function () {
        return {}
      }
    },
    multiple: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    name: {
      type: String,
      default: 'file'
    },
    listType: {
      type: String,
      default: 'picture-card'
    },
    limit: {
      type: Number,
      default: 9
    },
    beforeAvatarUpload: {
      type: Function,
      default: function () {
        return () => {}
      }
    },
    showFileList: {
      type: Boolean,
      default: true
    },
    drag: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: ''
    },
    // 只上传一张图片时，是否显示上传图片（用于按钮上传，不显示上传图片）
    showFile: {
      type: Boolean,
      default: true
    },
    pictureStyle: {
      // oss图片样式
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    height: {
      type: [Number, String],
      default: 0
    },
    width: {
      type: [Number, String],
      default: 0
    },
    isShowName: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'el-upload': Upload
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      isAdd: true,
      fileList: [], // 以上传的文件列表
      upload: this.$refs.upload,
      currentValue: this.value || []
    }
  },
  created () {
    this.fileList = this.build_file_list(this.value)
  },
  watch: {
    value: {
      handler: function (val, old) {
        if (val !== old) {
          this.currentValue = val
        }
      },
      immediate: true
    },
    currentValue: {
      handler (val, old) {
        if (this.limit && val && val.length >= this.limit) {
          this.isAdd = false
        } else {
          this.isAdd = true
        }
        if (val !== old) {
          this.$emit('input', this.currentValue)
        }
      },
      deep: true
    }
  },
  methods: {
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    submit () {
      this.upload.submit()
    },
    abort () {
      this.upload.abort()
    },
    onSuccess (res, file) {
      this.currentValue.push(this.build_file_item(this.isShowName ? file : file.response))
      this.$emit('input', this.currentValue)
    },
    onRemove (file, fileList) {
      this.currentValue = []
      if (fileList.length > 0) {
        fileList.forEach(ele => {
          this.currentValue.push(this.build_file_item(this.isShowName ? ele : ele.response))
        })
      }
      this.$emit('input', this.currentValue)
    },
    // 根据相对路径，获得图片的完整路径
    get_image_url (filePath) {
      return (
        this.imgUrl +
                filePath +
                (this.pictureStyle ? this.pictureStyle : '')
      )
    },
    build_file_item (filePath) {
      if (this.isShowName) {
        return {
          url: this.get_image_url(filePath.response || filePath.url),
          path: filePath.response || filePath.url,
          name: filePath.name
        }
      } else {
        return {
          url: this.get_image_url(filePath),
          path: filePath
        }
      }
    },
    build_file_list (value) {
      let list = []
      if (value && value.length > 0) {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            list.push(this.build_file_item(this.isShowName ? item : (item.response || item.url)))
          })
        } else {
          list.push(this.build_file_item(this.isShowName ? value : (value.response || value.url)))
        }
      }
      return list
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.wt-upload-file--no-add{
   .el-upload {
        display: none!important;
    }
}
    .wt-upload-file{
        &--no-add{
        .el-upload--picture-card {
            width: 100%;
            height: 100%;
            border: none;
            img {
                border-radius: 5px;
            }
    }
        }
    }
.bill{
    // ****
    // &__avatar{
    //     &--kkkk{

    //     }
    // }
    // &--active{

    // }
}
</style>
